import React from 'react'
import { Box, H3 } from '../layout'
import './Slides.css'

export const Slides = ({ title, slides }) => (
  <Box column fullWidth className="slides">
    {title}
    {slides.map(({ start, end, reverse }, index) => <Slide start={start} end={end} key={index} reverse={reverse} />)}
  </Box>
)

const Slide = ({ start, end, reverse }) => (
  <Box className={`slide ${reverse ? 'reverse-slide' : '' }`} >
    {start}
    {end}
  </Box>
)